var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkingHours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.481 511.481",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m379.294 216.48c16.05 0 31.57 2.34 46.23 6.69 6.167-115.846-83.575-215.558-197.729-223.17v55.48h-30v-55.48c-105.521 7.38-190.1 91.96-197.48 197.48h55.48v30h-55.48c7.61 114.153 107.327 203.898 223.17 197.73-31.754-101.525 49.058-210.47 155.809-208.73zm-68.919-122.79 21.21 21.21-21.21 21.21-21.21-21.21zm-195.161 237.58-21.21-21.21 21.21-21.21 21.21 21.21zm0-195.16-21.21-21.21 21.21-21.21 21.21 21.21zm43.581 91.37v-30h39v-75h30v105z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.224 351.28c16.673 4.703 30.331-14.167 20.72-28.49-3.37-5.06-9.13-8.4-15.65-8.4-21.928.55-25.825 30.599-5.07 36.89z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.294 381.98c-17.29 0-31.36 14.06-31.36 31.35 1.725 41.603 61.001 41.591 62.72 0 0-17.29-14.069-31.35-31.36-31.35z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.825 253.48c-83.919-29.762-176.263 36.213-175.029 125.501-.513 71.33 58.877 132.828 132.499 132.498 150.347-2.943 182.381-208.217 42.53-257.999zm-42.531 221.21c-58.659-.484-83.464-74.283-37.28-110.06-26.661-31.052-4.04-80.418 37.281-80.24 41.376.013 63.947 48.805 37.279 80.24 46.047 35.325 21.473 109.722-37.28 110.06z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingHours);
export default __webpack_public_path__ + "static/media/working-hours.5b593f8645c02078e5bb565b9c2cdc81.svg";
export { ForwardRef as ReactComponent };